/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ s: NonNullable<unknown>, ca: NonNullable<unknown> }} Pump_Missmatch_Error_TooltipInputs */



/**
* | output |
* | --- |
* | "Run feedback {s} is different from controller command {ca}" |
*
* @param {Pump_Missmatch_Error_TooltipInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const pump_missmatch_error_tooltip = /** @type {((inputs: Pump_Missmatch_Error_TooltipInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pump_Missmatch_Error_TooltipInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Run feedback ${i?.s} is different from controller command ${i?.ca}`)
	return /** @type {LocalizedString} */ (`Le retour de marche ${i?.s} est différent de la commande de l'automate ${i?.ca}`)
});